module.exports = __webpack_public_path__ + "img/three2Orange.e5f433f6.jpg";